import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { Subscription } from 'rxjs';

@AutoUnsubscribe()
@Component({
  selector: 'move-file-item',
  templateUrl: './move-file-item.component.html',
})
export class MoveFileItemComponent implements OnInit, OnDestroy {
  private dialogRef = inject(MatDialogRef<MoveFileItemComponent>);
  private inboxSettingsService = inject(InboxSettingsService);
  private vaultService = inject(SharedVaultService);

  private data = inject(MAT_DIALOG_DATA);

  subscription = new Subscription();
  searchText = '';
  filesList = signal([]);
  ngOnInit(): void {
    this.getFilesList();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onInputChange(value) {
    this.searchText = value;
  }
  clearSearchAction() {
    this.searchText = '';
  }
  getFilesList() {
    this.subscription.add(
      this.inboxSettingsService.getAllForms(this.data.currentuserId).subscribe((res) => {
        this.filesList.set(res?.data?.length > 0 ? res.data : []);
      })
    );
  }
  moveVaultFileItem(item) {
    this.subscription.add(
      this.vaultService
        .moveAttachmentFileItem({
          id: this.data.file.delete_id,
          user_id: this.data.currentuserId,
          vault_user_form_id: item.id,
        })
        .subscribe((res) => {
          this.dialogRef.close({ isRefresh: true });
        })
    );
  }
}
